import { Power0, Power3 } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class ArchiveHeader extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    const $paths = $el.find('.search-form-toggle path')

    this.timelineIn
      .fromTo(
        $el.find('.v-line'),
        0.6,
        { scaleY: 0 },
        { scaleY: 1, ease: Power3.easeInOut },
        0
      )
      .staggerFromTo(
        $el.find('.normal-title, .normal-subtitle'),
        0.6,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.2,
        0.3
      )
      .staggerFromTo(
        $el.find('.archive-header__nav .line'),
        0.3,
        { scaleY: 0 },
        { scaleY: 1, ease: Power3.easeInOut },
        0.1,
        1
      )
      .staggerFromTo(
        $el.find('.archive-header__nav .horizontal-nav li a'),
        0.6,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.2,
        1
      )
      .fromTo(
        $paths.first(),
        0.6,
        { drawSVG: '0%' },
        { drawSVG: '100%', ease: Power3.easeInOut },
        1.3
      )
      .fromTo(
        $paths.last(),
        0.3,
        { drawSVG: '0%' },
        { drawSVG: '100%', ease: Power3.easeInOut, onComplete: () => { $paths.addClass('allow-transition') } },
        1.6
      )
  }
}

export default ArchiveHeader



// WEBPACK FOOTER //
// ./scripts/components/ArchiveHeader.js